<div id="reception-pano"></div>

<button class="webinar-btn gsk-btn" mat-raised-button (click)="gotoLectureHall()">
    {{ "reception.buttons.lecturehall" | translate }}
</button>
